import React from "react";
import { Modal } from "react-bootstrap";

const PopupModal = ({ ...props }) => {
  const {
    title,
    popupShow,
    setPopupShow,
    children,
    size,
    dialogClassName,
    bodyClassName,
  } = props;

  return (
    <Modal
      show={popupShow}
      onHide={() => setPopupShow(false)}
      centered
      size={size}
      dialogClassName={dialogClassName}
      // backdrop="static"
      // keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={bodyClassName}>{children}</Modal.Body>
    </Modal>
  );
};

export default PopupModal;
